/**
 * ClassResults
 *
 * Service used to export class results to file
 *
 *
 */

import common from "@/services/Exporters/Common";
import fs from "@/services/FormatService";
import moment from "moment";

export default {
	exportCSV(vue) {
		let rubric = vue.rubric;
		let teacher = vue.user;
		let clazz = vue.classObj;
		let asmt = vue.assessment;

		var filenameFields = [
			"ClassResults",
			teacher.full_name,
			asmt.name,
			clazz.name
		];
		filenameFields.push(moment().format("M.D.YY-H.mm.ss"));

		var header = [
			"Teacher Name",
			"Teacher ID",
			"Class Name",
			"Class ID",
			"Assessment",
			"Administration",
			"Student Name",
			"Student ID",
			"Score Type",
			"Score Applied"
		];

		let traitNum = 1;
		_.each(rubric.traits, trait => {
			if (trait.separator) return;

			header.push(`Trait ${traitNum} Score`);
		});

		header.push("Final Score");

		var rows = [header];

		let scoreRows = ["first_score", "second_score", "res_score"];

		_.each(vue.deliveries, deliv => {
			_.each(deliv.responses, resp => {
				_.each(scoreRows, scoreRow => {
					let score = resp[scoreRow];
					if (!score) return;

					let row = [];
					row.push(teacher.full_name); //Teacher Name
					row.push(teacher.scorer_id); //Teacher ID
					row.push(clazz.name); //Class Name
					row.push(clazz.ref_id); //Class ID
					row.push(asmt.name); //Assessment
					row.push(deliv.name); //Administration
					row.push(resp.student_name); //Student Name
					row.push(resp.student_ref_id); //Student ID
					row.push(fs.scoreTypeName(score.score_type)); //Score Type
					row.push(fs.fullDate(score.created_at)); //Score Applied
					_.each(score.trait_scores, sp => {
						row.push(sp.score);
					});
					if (resp.final_score) {
						row.push(resp.weighted_score);
					} else {
						row.push("");
					}

					rows.push(row);
				});
			});
		});

		common.exportCSV(rows, filenameFields);
	}
};



// WEBPACK FOOTER //
// ./src/services/Exporters/ClassResults.js